import { useState } from 'react';
import { addClient } from '../services/api';
import { showErrorToast, showLoadingToast, updateLoadingToastSuccess, updateLoadingToastError } from '../utils/toastConfig';
import { FiX, FiUser, FiHash, FiMapPin, FiMap, FiBriefcase } from 'react-icons/fi';
import './AddClient.css';

const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Puducherry', 'Chandigarh',
  'Andaman and Nicobar Islands', 'Dadra and Nagar Haveli and Daman and Diu', 'Lakshadweep',
];

const AddClient = ({ closeModal, refreshClients }) => {
  const [form, setForm] = useState({
    client_name: '',
    address: '',
    gst_number: '',
    state: '',
    sector: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.client_name || !form.gst_number || !form.address || !form.state || !form.sector) {
      showErrorToast('Please fill in all required fields');
      return;
    }

    setLoading(true);
    const toastId = showLoadingToast('Adding client...');

    try {
      await addClient(form);
      updateLoadingToastSuccess(toastId, 'Client added successfully!');
      refreshClients();
      setTimeout(() => {
        closeModal();
      }, 1000);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Failed to add client';
      setError(errorMsg);
      updateLoadingToastError(toastId, errorMsg);
      setLoading(false);
    }
  };

  return (
    <div className="ac-overlay" onClick={closeModal}>
      <div className="ac-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="ac-header">
          <div>
            <h3>Add New Client</h3>
            <p className="ac-header-sub">Fill in the details to register a new client</p>
          </div>
          <button className="ac-close-btn" onClick={closeModal}>
            <FiX size={18} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="ac-form">
          {error && <div className="ac-error">{error}</div>}

          <div className="ac-form-grid">
            <div className="ac-field">
              <label><FiUser size={13} /> Client Name *</label>
              <input
                type="text"
                name="client_name"
                value={form.client_name}
                onChange={handleChange}
                placeholder="Enter client name"
                required
              />
            </div>
            <div className="ac-field">
              <label><FiHash size={13} /> GST Number *</label>
              <input
                type="text"
                name="gst_number"
                value={form.gst_number}
                onChange={handleChange}
                placeholder="e.g., 36AABCU9603R1ZM"
                maxLength={15}
                required
              />
            </div>
          </div>

          <div className="ac-field">
            <label><FiMapPin size={13} /> Address *</label>
            <textarea
              name="address"
              value={form.address}
              onChange={handleChange}
              placeholder="Enter full address"
              rows={3}
              required
            />
          </div>

          <div className="ac-form-grid">
            <div className="ac-field">
              <label><FiMap size={13} /> State *</label>
              <select name="state" value={form.state} onChange={handleChange} required>
                <option value="">Select State</option>
                {INDIAN_STATES.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </div>
            <div className="ac-field">
              <label><FiBriefcase size={13} /> Sector *</label>
              <select name="sector" value={form.sector} onChange={handleChange} required>
                <option value="">Select Sector</option>
                <option value="Education">Education</option>
                <option value="Information Technology">Information Technology</option>
              </select>
            </div>
          </div>

          {/* Actions */}
          <div className="ac-actions">
            <button type="button" className="ac-btn-cancel" onClick={closeModal}>
              Cancel
            </button>
            <button type="submit" className="ac-btn-submit" disabled={loading}>
              {loading ? (
                <>
                  <span className="ac-spinner"></span>
                  Adding...
                </>
              ) : (
                'Add Client'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddClient;
